import React, { useState, useEffect } from 'react';
import { ChevronDown20, Wikis20 } from '@carbon/icons-react';
import i18next from 'translations/i18n';
import { languages } from 'components/translation/Translation';
import { useToggle } from 'hooks/useToggle';
import { useResponsiveRender } from 'hooks/useResponsiveRender';
import { useClickOutside } from 'hooks/useClickOutside';
import { useOnChangeLocation } from 'hooks/useOnChangeLocations';
import './translationDropdown.scss';

const TranslationDropdown = () => {
  const [language, setLanguage] = useState(i18next.language);
  const [isOpenMenu, toggleMenu, onCloseMenu] = useToggle(false);

  const domRef = useClickOutside(() => {
    if (isOpenMenu) toggleMenu();
  });

  useEffect(() => {
    const handleLanguageChange = (lang) => {
      setLanguage(lang);
    };

    handleLanguageChange(i18next.language);

    const unsubscribe = () => {
      i18next.off('languageChanged', handleLanguageChange);
    };

    i18next.on('languageChanged', handleLanguageChange);

    return unsubscribe;
  }, []);

  useOnChangeLocation(() => onCloseMenu());

  const handleLanguage = (lang) => {
    i18next.changeLanguage(lang);
    setLanguage(lang);

    toggleMenu();
  };

  const { renderMobile: mobileRender } = useResponsiveRender({ breakpoint: 768 });

  const longName = (lang) => (lang === 'en' ? 'English' : 'Español');

  return (
    <div className="translationDropdown" onClick={toggleMenu} ref={domRef}>
      <Wikis20 />
      <span>{mobileRender ? language?.toUpperCase() : longName(language)}</span>
      <ChevronDown20 />

      <ul className="translationDropdown_menu">
        {isOpenMenu &&
          Object.values(languages).map((lang, index) => (
            <li key={index} onClick={() => handleLanguage(lang)}>
              {mobileRender ? lang?.toUpperCase() : longName(lang)}
            </li>
          ))}
      </ul>
    </div>
  );
};

export default TranslationDropdown;
